import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { HttpHeaders, HttpClient, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

    constructor(private router: Router, private authenticationService: AuthenticationService) { }

    intercept(request: import("@angular/common/http").HttpRequest<any>, next: import("@angular/common/http").HttpHandler): Observable<import("@angular/common/http").HttpEvent<any>> {
        // nao autenticado
        if (localStorage.getItem('token') == null) {
            return next.handle(request);
        }

        // autenticado => token
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return next.handle(request).pipe(tap(() => { },
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    // por problemas/restricoes na implementação do CORS no ASPNET.WEBAPI, que não inclui os headers relativos
                    // ao CORS nas respostas com status diferentes de 200, o browser repassa o resultado da requisicao como 0 (e nao 401, como deveria)
                    if (err.status !== 0 && err.status !== 401) {
                        return;
                    }
                    this.authenticationService.logout();
                    location.reload(true);
                }
            }));
    }
}
